export enum FontAlignmentEnum {
    'left' = 'left',
    'center' = 'center',
    'right' = 'right'
}
